module.exports = __webpack_public_path__ + "img/Edith.f8525ab4.png";